export default function Footer() {
    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,500;0,600;1,400&family=DM+Sans:wght@300;400;500&display=swap');
                .footer-link {
                    color: rgba(255,255,255,0.45);
                    font-family: 'DM Sans', sans-serif;
                    font-size: 13px;
                    text-decoration: none;
                    transition: color 0.25s ease;
                }
                .footer-link:hover { color: rgba(255,255,255,0.9); }
                .footer-divider {
                    width: 100%;
                    height: 1px;
                    background: rgba(255,255,255,0.07);
                    margin: 40px 0;
                }
            `}</style>

            <footer
                className="relative bg-[#0e0d0b]"
                style={{ paddingTop: "72px", paddingBottom: "40px" }}
            >
                <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">

                    {/* ── Top row: brand + nav columns ──────────────────────── */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-12 lg:gap-8">

                        {/* Brand */}
                        <div className="lg:col-span-2">
                            <p
                                className="text-2xl font-light text-white mb-3"
                                style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
                            >
                                Alive <em className="not-italic text-amber-300">Paris</em>
                            </p>
                            <p
                                className="text-sm leading-relaxed max-w-xs"
                                style={{ fontFamily: "'DM Sans', sans-serif", color: "rgba(255,255,255,0.4)", fontWeight: 300 }}
                            >
                                Premium room rentals and properties across the most beautiful cities of France. Find your ideal home away from home.
                            </p>

                            {/* Social icons */}
                            <div className="flex items-center gap-3 mt-6">
                                {[
                                    { label: "Instagram", path: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z", url: 'https://www.instagram.com/alive_paris_?igsh=aDExNzdlcjU4dXh2' },
                                    // { label: "Facebook", path: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" },
                                    // { label: "LinkedIn", path: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" },
                                ].map(({ label, path, url }) => (
                                    <a
                                        key={label}
                                        href={url}
                                        target="_blank"
                                        aria-label={label}
                                        className="w-8 h-8 rounded-full border border-white/10 flex items-center justify-center
                                                   hover:border-white/30 hover:bg-white/5 transition-all duration-300"
                                    >
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="rgba(255,255,255,0.45)">
                                            <path d={path} />
                                        </svg>
                                    </a>
                                ))}
                            </div>
                        </div>

                        {/* Explore */}
                        <div>
                            <p className="text-xs uppercase tracking-[0.2em] text-white/30 mb-5"
                                style={{ fontFamily: "'DM Sans', sans-serif" }}>
                                Explore
                            </p>
                            <ul className="flex flex-col gap-3">
                                {[
                                    { label: "Rooms", href: "/accommodation" },
                                    { label: "Cities", href: "/accommodation" },
                                    { label: "Luxury Rentals", href: "/accommodation" },
                                    { label: "New Listings", href: "/accommodation" },
                                ].map((item) => (
                                    <li key={item.label}>
                                        <a
                                            href={item.href}
                                            className="footer-link hover:text-white transition-opacity duration-300"
                                            style={{ opacity: 0.8 }}
                                        >
                                            {item.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Company */}
                        <div>
                            <p className="text-xs uppercase tracking-[0.2em] text-white/30 mb-5"
                                style={{ fontFamily: "'DM Sans', sans-serif" }}>
                                Company
                            </p>
                            <ul className="flex flex-col gap-3">
                                {[
                                    { label: "Home", href: "/" },
                                    { label: "About Us", href: "/about" },
                                    { label: "Find a Room", href: "/accommodation" },
                                    { label: "Contact", href: "/contact" },
                                ].map((item) => (
                                    <li key={item.label}>
                                        <a
                                            href={item.href}
                                            className="footer-link hover:text-white transition-opacity duration-300"
                                            style={{ opacity: 0.8 }}
                                        >
                                            {item.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Contact */}
                        <div>
                            <p className="text-xs uppercase tracking-[0.2em] text-white/30 mb-5"
                                style={{ fontFamily: "'DM Sans', sans-serif" }}>
                                Contact
                            </p>
                            <ul className="flex flex-col gap-3">
                                <li>
                                    <a href="mailto:hello@aliveparis.com" className="footer-link">
                                        info@aliveparis.com
                                    </a>
                                </li>
                                {/* <li>
                                    <a href="tel:+33142000000" className="footer-link">
                                        +33 1 42 00 00 00
                                    </a>
                                </li> */}
                                {/* <li>
                                    <span className="footer-link" style={{ cursor: "default" }}>
                                        12 Rue de Rivoli<br />Paris, 75001
                                    </span>
                                </li> */}
                            </ul>
                        </div>

                    </div>

                    {/* ── Divider ────────────────────────────────────────────── */}
                    <div className="footer-divider" />

                    {/* ── Bottom row ─────────────────────────────────────────── */}
                    <div className="flex flex-col sm:flex-row items-center justify-between gap-4">

                        <p
                            className="text-xs"
                            style={{ fontFamily: "'DM Sans', sans-serif", color: "rgba(255,255,255,0.25)" }}
                        >
                            &copy; {new Date().getFullYear()} Alive Paris. All rights reserved.
                        </p>

                        <div className="flex items-center gap-6">
                            {[
                                { label: "Privacy Policy", href: "/privacy-policy" },
                                // { label: "Terms of Use", href: "/terms-of-use" },
                                // { label: "Cookie Settings", href: "/cookies" },
                            ].map((item) => (
                                <a
                                    key={item.label}
                                    href={item.href}
                                    className="footer-link hover:text-white transition-colors"
                                    style={{ fontSize: "12px", opacity: 0.7 }}
                                >
                                    {item.label}
                                </a>
                            ))}
                        </div>

                    </div>

                </div>
            </footer>
        </>
    );
}